import { DiscussionTopic } from "./OPR3/DiscussionTopics";
import { IssueAndPlanOfManagement } from "./OPR3/IssueAndPlanOfManagement";
import { OntarioObstetricalRecommendedImmuniprophylaxis } from "./OPR3/OntarioObstetricalRecommendedImmuniprophylaxis";
import { OntarioObstetricalSpecialCircumstances } from "./OPR3/OntarioObstetricalSpecialCircumstances";
import { OntarioObstetricalSwabResultEnum } from "./OPR3/OntarioObstetricalSwabResultEnum";
import { OntarioObstetricalVisit } from "./OPR3/OntarioObstetricalVisit";

class OntarioObstetricalFileFormOpr3 {
    public IssuePlanOfManagement: IssueAndPlanOfManagement[];
    public RecommendedImmuniprophylaxis: OntarioObstetricalRecommendedImmuniprophylaxis;
    public SpecialCircumstances: OntarioObstetricalSpecialCircumstances;
    public GbsRectovaginalSwab: OntarioObstetricalSwabResultEnum = OntarioObstetricalSwabResultEnum.None;
    public OtherIndicationsForProxphylaxis?: boolean;
    public SubsequentVisits: OntarioObstetricalVisit[];
    public DiscussionTopics: DiscussionTopic[];
    public DiscussionTopicsComments: string;
    public CopyOfOpr2UpdatedAndOpr3ToHospital?: boolean;
    public CopyOfOpr2UpdatedAndOpr3AndOrToPatientOrClient?: boolean;
    public InitialsMapping: string[];

    constructor(fields?: Partial<OntarioObstetricalFileFormOpr3>) {
        this.InitialsMapping = ["", "", "", "", ""];
        Object.assign(this, fields);
        this.IssuePlanOfManagement = fields?.IssuePlanOfManagement?.map(p => new IssueAndPlanOfManagement(p)) ?? [];
        this.SubsequentVisits = fields?.SubsequentVisits?.map(s => new OntarioObstetricalVisit(s)) ?? [];
        this.DiscussionTopics = fields?.DiscussionTopics ?? [];
        this.RecommendedImmuniprophylaxis = new OntarioObstetricalRecommendedImmuniprophylaxis(fields?.RecommendedImmuniprophylaxis);
        this.SpecialCircumstances = new OntarioObstetricalSpecialCircumstances(fields?.SpecialCircumstances);
    }
}

export { OntarioObstetricalFileFormOpr3 };
